import DatabaseManager from '../data/DatabaseManager';

/**
 * Point of data access for Newsletter related stuff
 */

export default {

	registerBetaEntry(email) {
		return DatabaseManager.newBetaSignup(email)
	},
}



// WEBPACK FOOTER //
// ./src/repositories/NewsletterRepository.js